import { render } from "./dsr_wise_sale_card.vue?vue&type=template&id=4c9898d2&scoped=true"
import script from "./dsr_wise_sale_card.vue?vue&type=script&lang=js"
export * from "./dsr_wise_sale_card.vue?vue&type=script&lang=js"

import "./dsr_wise_sale_card.vue?vue&type=style&index=0&id=4c9898d2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c9898d2"]])

export default __exports__